import { refreshScheduler } from './scheduler';
import { getCurrentUserOrgUnits } from '../../entities';
import { SELECTED_DATE_UPDATE } from '../../constants/types';

function selectDate(date) {
  return {
    type: SELECTED_DATE_UPDATE,
    date,
  };
}

function selectDateAndUpdate(date) {
  return dispatch => {
    dispatch(selectDate(date));
  };
}

function selectDateAndUpdateReload(date, currentPath) {
  return dispatch => {
    dispatch(selectDate(date));
    if (currentPath.includes('DailyPlanning')) dispatch(refreshScheduler());
    dispatch(getCurrentUserOrgUnits(date));
  };
}

export { selectDateAndUpdate, selectDateAndUpdateReload };
